import { Type } from 'class-transformer'
import { IsIn, IsInt, IsNotEmpty, IsOptional, IsString, ValidateIf } from 'class-validator'

export class Container {
  id: number | null
  number: string
  name: string
  locationLatitude?: string | null
  locationLongitude?: string | null
  status: number | undefined
  region?: string | any
  regionId?: number | null
  locationType?: 'factory' | 'gps'
  factoryId?: number
  factoryName?: string

  constructor(container?: Container) {
    this.id = container?.id ?? null
    this.number = container?.number ?? ''
    this.name = container?.name ?? ''
    this.locationLatitude = container?.locationLatitude ?? null
    this.locationLongitude = container?.locationLongitude ?? null
    this.status = container?.status
    this.region = container?.region ?? null
    this.regionId = container?.regionId ?? null
    this.locationType = container?.locationType ?? undefined
    this.factoryId = container?.factoryId ?? undefined
    this.factoryName = container?.factoryName ?? undefined
  }
}

export class CreateUpdateContainerDto {
  @IsInt()
  @IsOptional()
  id?: number

  @IsString()
  number!: string

  @IsString()
  name!: string

  @IsOptional()
  @ValidateIf((o) => o.locationType === 'gps')
  @IsString()
  locationLatitude?: string

  @IsOptional()
  @ValidateIf((o) => o.locationType === 'gps')
  @IsString()
  locationLongitude?: string

  @IsInt()
  @IsOptional()
  status?: number

  @IsString()
  @IsIn(['factory', 'gps'])
  locationType!: 'factory' | 'gps'

  @ValidateIf((o) => o.locationType === 'factory')
  @Type(() => Number)
  @IsInt()
  @IsNotEmpty()
  factoryId?: number
}
